import IEnum from '../interfaces/IEnum';

export const InscriptionDocumentOrigin: IEnum = {
    translations: {
        0: 'lang.shared.inscriptionProof',
        1: 'lang.shared.claimProof',
        2: 'lang.shared.inscriptionReceipt',
        3: 'lang.shared.claimReceipt',
        4: 'lang.shared.attachMeritProof',
        5: 'lang.shared.meritsReceip',
        6: 'lang.shared.paymentReceipt',
        7: 'lang.shared.representativeAuthorization',
    },
    enum: {
        JUSTIFY: 0,
        CORRECTION: 1,
        JUSTIFYRECEIPT: 2,
        CORRECTIONRECEIPT: 3,
        JUSTIFYMERIT: 4,
        MERITSRECEIPT: 5,
        PAYMENTDOCUMENT: 6,
        REPRESENTATIVEAUTHORIZATION: 7
    },
    order: {
        0: 0,
        1: 2,
        2: 1,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7
    }
};
